// bookie-plum-preview — bk24 "Olxo'ri Guli" preview card.
//
// Plum-blossom bookie card. A soft plum gradient surrounds a cream inner
// card; an inline plum branch with five blossoms arcs across the medallion
// space, names render in Cormorant Garamond, and the venue line sits beneath.
import { Photo, type LayoutCtx } from "./_shared";

export function BookiePlumPreviewLayout({ names, date, venue, accent, ink, bg, font, photo }: LayoutCtx) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `linear-gradient(135deg, ${accent}33 0%, ${bg} 40%, ${accent}1A 100%)`,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          position: "relative",
          background: bg,
          color: ink,
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55`,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          TAKLIFNOMA
        </div>

        {/* Plum blossom branch */}
        <div style={{ width: "62%", aspectRatio: "1 / 1", marginBottom: "5%", position: "relative" }}>
          <Photo
            src={photo}
            style={{ position: "absolute", inset: "12%", borderRadius: "50%" }}
            fallback={
              <svg viewBox="0 0 100 100" style={{ width: "100%", height: "100%", display: "block" }}>
                <defs>
                  <radialGradient id="plumPaper" cx="50%" cy="50%">
                    <stop offset="0%" stopColor={bg} />
                    <stop offset="100%" stopColor={`${accent}14`} />
                  </radialGradient>
                </defs>
                <circle cx="50" cy="50" r="44" fill="url(#plumPaper)" stroke={accent} strokeWidth="0.5" opacity="0.5" />
                {/* Main branch */}
                <path d="M14 80 Q 35 60 60 50 Q 78 44 88 30"
                      fill="none" stroke={`${ink}AA`} strokeWidth="0.8" strokeLinecap="round" />
                <path d="M40 62 Q 48 70 56 68"
                      fill="none" stroke={`${ink}88`} strokeWidth="0.6" strokeLinecap="round" />
                <path d="M70 42 Q 72 36 78 32"
                      fill="none" stroke={`${ink}88`} strokeWidth="0.6" strokeLinecap="round" />
                {/* Five plum blossoms */}
                {[
                  { x: 24, y: 70, r: 5 },
                  { x: 44, y: 58, r: 6 },
                  { x: 60, y: 50, r: 5 },
                  { x: 76, y: 38, r: 6 },
                  { x: 56, y: 70, r: 4 },
                ].map((b, i) => (
                  <g key={i} transform={`translate(${b.x} ${b.y})`}>
                    {[0, 72, 144, 216, 288].map((d) => (
                      <ellipse key={d} cx="0" cy={-b.r * 0.55} rx={b.r * 0.45} ry={b.r * 0.6}
                               fill={accent} opacity="0.75" transform={`rotate(${d})`} />
                    ))}
                    <circle r={b.r * 0.25} fill={accent} />
                  </g>
                ))}
              </svg>
            }
          />
        </div>

        <div style={{ fontFamily: font, fontSize: 30, lineHeight: 1.05, color: ink }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          TAKLIFNOMA · {date}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
